<div class="modal notification-modal" tabindex="-1" role="dialog" *ngIf="activateModal">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" (click)="closeModal()" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h4 class="modal-title">Pronunciation Editor</h4>
            </div>
            <div class="modal-body">
                <div>
                    <div class="pipeline-pronunciations-text col-md-6">
                        {{currentIndex+1}}/{{numMissingEntries()}}
                    </div>
                    <div class="pipeline-pronunciations-text col-md-6">
                    <label class="form-check-label" for="isSelected">
                        <input class="form-check-input" id="isSelected" type="checkbox"
                               [checked]="enterAsWords"
                               [(ngModel)]="enterAsWords"> Enter As Words </label>
                    </div>
                    <div *ngIf="!enterAsWords" class="pipeline-pronunciations-text col-md-12">
                        Near Matches:
                    </div>
                    <ol>
                        <li class="pipeline-pronunciations-list" *ngFor="let match of enterAsWords?[]:nearMatches">
                            {{getPronunciations(match)}}
                        </li>
                    </ol>

                    <ul>
                        <li class="pipeline-pronunciations-text" *ngIf="!!currentWord">
                            <label>{{currentWord}}<input type="input"
                                                               [(ngModel)]="currentValues[0]"></label>
                        </li>
                        <li class="pipeline-pronunciations-text" *ngIf="!currentWord">
                            FINISHED ALL!!
                        </li>
                    </ul>

                    <ol>
                        <li class="pipeline-pronunciations-list" *ngFor="let savedEntry of savedEntries()">
                            {{savedEntry}}
                        </li>
                    </ol>
                    <div class="row">
                        <div class="col-md-4">
                            <button class="btn btn-sm pull-md-right" type="button"
                                    [disabled]="!validValues() || !currentWord"
                                    (click)="addValue()">Add Entry
                            </button>
                        </div>
                    </div>
                    <hr/>
                    <div class="row">
                        <div class="col-md-4">
                            <button class="btn btn-sm button-primary pull-md-right" type="button"
                                    [disabled]="numMissingEntries() === 0 || !entryValid()"
                                    (click)="goNextWord(true)">Save/Next
                            </button>
                        </div>
                        <div class="col-md-4">
                            <button class="btn btn-sm button-secondary pull-md-right" type="button"
                                    [disabled]="!nextWord()"
                                    (click)="goNextWord(false)">Forward
                            </button>
                        </div>
                        <div class="col-md-4">
                            <button class="btn btn-sm button-secondary pull-md-right" type="button"
                                    [disabled]="!previousWord()"
                                    (click)="goPreviousWord()">Back
                            </button>
                        </div>
                    </div>
                    <hr/>
                    <div class="row">
                        <div class="col-md-4">
                            <button class="btn btn-sm pull-md-right" type="button"
                                    [disabled]="!validValues() && currentValues[0] !== ''"
                                    (click)="saveAll()">Save Recognizer Data
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
